import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Estado } from "../../../../shared/shared/estado.enum";
import {
  ICadastro
} from "../interface-regional-parametro";
import { ServiceAppService } from "../../../../security/service-app.service";
import { MessageService } from "primeng/api";
import * as XLSX from "xlsx";

@Component({
  selector: "app-regional-parametro-cadastro",
  templateUrl: "./regional-parametro-cadastro.component.html",
  styleUrls: ["./regional-parametro-cadastro.component.scss"],
})
export class RegionalParametroCadastroComponent implements OnInit {
  @Input() cadastro: ICadastro;
  @Input() exibeCadastro: boolean;
  @Input() cadastroTitulo: string;
  @Input() state: Estado;
  @Output() recarregarDados: EventEmitter<any> = new EventEmitter<any>();
  @Output() fecharModalCadastro: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  submitted: boolean;
  isForm: boolean = true;

  constructor(
    private service: ServiceAppService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.submitted = false;
  }

  saveDados() {
    this.submitted = true;


    let listaCadastros: any[] = [];

    listaCadastros.push(this.cadastro);
    this.aplicaSaveDados(listaCadastros);
    this.exibeCadastro = false;
  }

  aplicaSaveDados(dados: ICadastro[]) {
    const isInsert = this.state === Estado.insert;
    const pathRequest = isInsert
      ? "/regional_venda/insereRegistro"
      : "/regional_venda/alteraRegistro";
    const message = isInsert
      ? "Cadastro realizado com sucesso!"
      : "Alteração realizada com sucesso!";

    let request;

    if (isInsert) {
      const camposVazios = this.verificarCamposVazios(this.cadastro);

      if (camposVazios.length === 0){
        const listaCadastros = { dados };
        request = this.service.postDados(pathRequest, listaCadastros);
      }else {      
          this.exibeCadastro = true;
      }
    } else {
      // Realiza a requisição PUT com os dados já existentes no this.cadastro
      request = this.service.putDados(pathRequest, this.cadastro);
    }

    request.subscribe(
      (res) => {
        this.messageService.add({
          key: "regional-parametro",
          severity: "success",
          summary: "Sucesso",
          detail: message,
          life: 3000,
        });
        this.recarregarDados.emit();
      },
      (error) => {
        this.messageService.add({
          key: "regional-parametro",
          severity: "error",
          summary: "Erro",
          detail: error.erro,
          life: 3000,
        });
        this.recarregarDados.emit();
      }
    );
  }

  uploader(event) {
    const json = this.convertExcelToJson(event);
  }

  convertExcelToJson(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.files[0];

    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: "binary" });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      this.insertArquivo(JSON.stringify(jsonData));
    };
    reader.readAsBinaryString(file);
  }

  insertArquivo(json) {
    var row = JSON.parse(json);
    var verifica = this.verificaArquivo(row);
    if (verifica) {
      let listaCadastros = [];

      console.log
      for (let i = 0; i < row.NBS.length; i++) {
        if (
          typeof row.NBS[i].dealer === "undefined" ||
          typeof row.NBS[i].categoria === "undefined" ||
          typeof row.NBS[i].mes === "undefined" ||
          typeof row.NBS[i].ano === "undefined" ||
          typeof row.NBS[i].valor === "undefined" ||
          typeof row.NBS[i].monetario === "undefined"
        ) {
          alert("Arquivo com erro na linha " + (i + 2));
        } else {
          let novoCadastro = { ...this.cadastro };
          // novoCadastro.id = 0;
          // novoCadastro.id_dealer = row.NBS[i].dealer.toString();
          // novoCadastro.id_categoria_venda = row.NBS[i].categoria.toString();
          // novoCadastro.mes = row.NBS[i].mes.toString();
          // novoCadastro.ano = row.NBS[i].ano.toString();
          // novoCadastro.valor = row.NBS[i].valor.toString();
          // novoCadastro.tipo_valor = row.NBS[i].monetario.toString();
          listaCadastros.push(novoCadastro);
        }
      }
      this.aplicaSaveDados(listaCadastros);
      this.exibeCadastro = false;
    }
  }

  verificaArquivo(row) {
    var teste = [];

    console.log(row.Planilha1)
    for (let i = 0; i < row.NBS.length; i++) {
      teste.push(
        row.Planilha1[i].Contato?.toString() +
          row.Planilha1[i].categoria?.toString() +
          row.Planilha1[i].mes?.toString() +
          row.Planilha1[i].ano?.toString()
      );
    }
    if (!this.hasDuplicates(teste)) {
      return true;
    } else {
      const mensagem = "Arquivo Com Itens Duplicados";
      this.messageService.add({
        key: "regional-parametro",
        severity: "error",
        summary: "Erro",
        detail: mensagem,
        life: 3000,
      });
    }
  }

  hasDuplicates(array) {
    return new Set(array).size !== array.length;
  }

  hideDialog() {
    this.isForm = true;
    this.submitted = false;
    this.exibeCadastro = false;
    this.fecharModalCadastro.emit(this.exibeCadastro);
  }

  alteraFormulario() {
    this.isForm = !this.isForm;
  }

  verificarCamposVazios(cadastro: ICadastro): string[] {
    const camposVazios: string[] = [];
    const camposObrigatorios: (keyof ICadastro)[] = [
      'descricao_regiao', 'nome_contato', 'ddd_contato', 'telefone_contato', 'email_contato'
    ];

    camposObrigatorios.forEach(key => {
      if (cadastro[key] === "" || cadastro[key] === null || cadastro[key] === undefined) {
        camposVazios.push(key);
      }
    });

    return camposVazios;
  }
}
